<template>
  <div>
    <div class="titlePage">Campos Finalizados</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsCorrecaoCadastral"
          :orderby="sortBy"
          :items="lstControle"
          responsive
          :optionsButton="optionsCorrecaoCadastral"
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
export default {
  data() {
    return {
      titlePage: 'Publicações',
      sortBy: 'nome',
      itemPorPage: '1000',
      visualizaExportar: false,
      visualizaLiberar: false,
      liberarForm: false,
      tppublicacao: 0,
      lstControle: [],
      lstCorrecaoCadastral: [],
      permissao: {},
      optionsCorrecaoCadastral: [],
      fieldsCorrecaoCadastral: [
        { key: 'nmfuncionario', label: 'Técnico', sortable: true },
        { key: 'data', label: 'Data', sortable: true },
        { key: 'descricao', label: 'Status' }
      ]
    }
  },
  props: {
    idNotificacao: Number,
    spi: String
  },
  methods: {
    publicarControle() {
      this.callConfirm('Deseja realmente publicar?', '').then((result) => {
        if (result.value) {
          axios
            .post(
              store.state.baseUrlPublicacao +
                'PublicacaoCorrecaoCadastral/PublicarCorrecaoCadastral',
              this.idNotificacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarControleStatus()
            })
        }
      })
    },
    importarControle() {
      this.callConfirm('Deseja realmente importar?', '').then((result) => {
        if (result.value) {
          axios
            .post(
              store.state.baseUrlPublicacao +
                'PublicacaoCorrecaoCadastral/FinalizarPublicacaoCorrecaoCadastral',
              this.idNotificacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarControleStatus()
            })
        }
      })
    },
    gerarTabela() {
      this.callConfirm('Deseja realmente gerar tabela?', '').then((result) => {
        if (result.value) {
          const payload = {
            spi: this.spi,
            usuario: this.dadosUserSession.usuID,
            idPublicacao: this.idNotificacao
          }
          axios
            .post(
              store.state.baseUrlPublicacao + 'PublicacaoCorrecaoCadastral/GerarTabelaCorrecao',
              payload,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callAlert(
                'Tabela em processamento',
                'Geração de tabela enviado para fila de processamento, aguarde uma notificação (Email/SGP).',
                'success',
                'success'
              )
              this.listarControleStatus()
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    verificaTipo(tpPublicacao) {
      switch (tpPublicacao) {
        case 2:
          this.optionsCorrecaoCadastral = [
            {
              funcaoButton: 'publicarControle',
              tooltip: 'Publicar',
              icon: 'upload',
              variant: 'primary',
              text: 'Publicar',
              objpermCodigo: store.state.permissaoMenu.adicionar
            },
            {
              funcaoButton: 'gerarTabela',
              tooltip: 'Gerar Tabela',
              icon: 'table',
              variant: 'primary',
              text: 'Gerar Tabela',
              objpermCodigo: store.state.permissaoMenu.adicionar
            }
          ]
          break
        case 4:
          this.optionsCorrecaoCadastral = [
            // {
            //   funcaoButton: 'importarControle',
            //   tooltip: 'Importar',
            //   icon: 'import',
            //   variant: 'primary',
            //   text: 'Importar',
            //   objpermCodigo: store.state.permissaoMenu.adicionar
            // },
            {
              funcaoButton: 'gerarTabela',
              tooltip: 'Gerar Tabela',
              icon: 'table',
              variant: 'primary',
              text: 'Gerar Tabela',
              objpermCodigo: store.state.permissaoMenu.adicionar
            }
          ]
          break
        default:
          this.optionsCorrecaoCadastral = []
          break
      }
    },
    listarControleStatus() {
      axios
        .get(
          store.state.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/CorrecaoCadastralStatus/' +
            this.idNotificacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstControle = response.data
          if (this.lstControle.length > 0) {
            this.tppublicacao = this.lstControle[this.lstControle.length - 1].tppublicacao
            this.$emit('controleCorrecao', this.tppublicacao)
            this.verificaTipo(this.tppublicacao)
          }
        })
    }
  },
  mounted() {
    this.optionsCargos = []
    this.listarControleStatus()
  }
}
</script>
